// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Table-module--tableWrapper--2MYYB","table":"Table-module--table--7Gq3z","tableCell":"Table-module--tableCell--2W7hj","tableRow":"Table-module--tableRow--3CyIZ"};